import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'
import i18n, { initializeLanguage } from './locales'
import 'uno.css'
import './styles/main.scss'
import 'vant/lib/index.css'; // 引入 Vant 样式

// 设置初始标题
document.title = import.meta.env.VITE_APP_TITLE || '集换社 - 专业的卡牌交易平台'

const app = createApp(App)

// import wxOpenApp from '@/components/wxOpenApp.vue'
// app.component('wxOpenApp', wxOpenApp)

// 忽略自定义元素标签抛出的报错
app.config.compilerOptions.isCustomElement = (tag) => {
  return ['wx-open-launch-app'].includes(tag)
}

app.use(router)
app.use(pinia)
app.use(i18n)

// 初始化语言设置
initializeLanguage().catch(console.error)

app.mount('#app')
